"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convertToDate_1 = require("./convertToDate");
var atai_1 = require("./atai");
var seireki_1 = require("./seireki");
var wareki_1 = require("./wareki");
var tsuki_1 = require("./tsuki");
var hi_1 = require("./hi");
var tanYobi_1 = require("./tanYobi");
var yobi_1 = require("./yobi");
var ji_1 = require("./ji");
var fun_1 = require("./fun");
var byo_1 = require("./byo");
var haku_1 = require("./haku");
var ha_1 = require("./ha");
function hizuke(date, state) {
    if (date === void 0) { date = new Date(); }
    if (state === void 0) { state = []; }
    function setState(value) {
        state.push(value);
        return hizuke(date, state);
    }
    function fixDigit(value) {
        var index = state.length - 1;
        state[index] = state[index].replace(/^(.*?)(\d+)(.*?)$/, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return args[1] + ("00000" + args[2]).slice(-value) + args[3];
        });
        return hizuke(date, state);
    }
    function output() {
        return state.join('');
    }
    var date1 = convertToDate_1.default(date);
    return {
        seireki: function (unit) { return setState(seireki_1.default(date1, unit)); },
        wareki: function (unit) { return setState(wareki_1.default(date1, 'full', unit)); },
        tanWareki: function (unit) { return setState(wareki_1.default(date1, 'short', unit)); },
        alphaWareki: function (unit) { return setState(wareki_1.default(date1, 'alpha', unit)); },
        tsuki: function (unit) { return setState(tsuki_1.default(date1, unit)); },
        hi: function (unit) { return setState(hi_1.default(date1, unit)); },
        tanYobi: function (unit) { return setState(tanYobi_1.default(date1, unit)); },
        yobi: function (unit) { return setState(yobi_1.default(date1, unit)); },
        ji: function (unit) { return setState(ji_1.default(date1, unit)); },
        fun: function (unit) { return setState(fun_1.default(date1, unit)); },
        byo: function (unit) { return setState(byo_1.default(date1, unit)); },
        haku: function (value) { return setState(haku_1.default(value)); },
        niketa: function () { return fixDigit(2); },
        moji: output,
        atai: function () { return atai_1.default(date1); },
        ha: function (date2) { return ha_1.default(date1, convertToDate_1.default(date2)); }
    };
}
exports.default = hizuke;
